export type DictionaryRow = {
  table: ValidTableName;
  characteristic: string | null;
  format: string | null;
  abbreviation: string | null;
  definition: string | null;
  is_slice_filter: boolean;
};
import type { ValidTableName } from '~/types/supabase-client';
import dataDictionary from '~/lib/data-dictionary/data_dictionary.json';

export default (tableNames: ValidTableName[]) => {
  // Create deep copies of dictionary rows to prevent mutations from affecting other pages
  const dictionary = ref<DictionaryRow[]>(
    dataDictionary.map((row) => ({ ...row })) as DictionaryRow[]
  );
  const localDictionary = ref(
    dictionary.value.filter((row) => tableNames.includes(row.table)).map((row) => ({ ...row })) // Deep copy each row
  );
  let dictionaryFilterRows = computed(() => {
    return localDictionary.value.filter((row) => row.is_slice_filter === true);
  });

  const formatData = (dictionaryRow: DictionaryRow, value: number | string) => {
    if (!dictionaryRow) {
      console.error('useDataDictionary :: formatData :: invalid dictionary');
      return value;
    }
    if (value == null) {
      console.error('useDataDictionary :: formatData :: invalid value');
      return value;
    }
    let formattedValue = value;
    if (dictionaryRow.format == '#.###') {
      formattedValue =
        typeof formattedValue == 'string'
          ? parseFloat(formattedValue).toFixed(3)
          : formattedValue.toFixed(3);
    } else if (dictionaryRow.format == '#.##') {
      formattedValue =
        typeof formattedValue == 'string'
          ? parseFloat(formattedValue).toFixed(2)
          : formattedValue.toFixed(2);
    } else if (dictionaryRow.format == '#.####') {
      formattedValue =
        typeof formattedValue == 'string'
          ? parseFloat(formattedValue).toFixed(4)
          : formattedValue.toFixed(4);
    } else if (dictionaryRow.format == '#.##%') {
      // formattedValue = `${(parseFloat(formattedValue) * 100).toFixed(2)}%`;
      if (typeof formattedValue == 'number') {
        formattedValue = (formattedValue * 100).toFixed(2) + '%';
      } else if (formattedValue.indexOf('%') == -1) {
        formattedValue += '%';
      }
    }
    return formattedValue;
  };

  const parseData = <T>(data: Record<any, any>[]): T[] => {
    if (data == null || data == undefined) return data;
    let fields = Object.keys(Array.isArray(data) && data.length ? data[0] : {});
    let matchedDictionaryRows = localDictionary.value.filter(
      (dictionaryRow) =>
        dictionaryRow.characteristic !== null && fields.includes(dictionaryRow.characteristic)
    );

    const formattedData = [...data];

    try {
      data.map((row, index) => {
        matchedDictionaryRows.map((matchedDictionaryRow) => {
          if (matchedDictionaryRow.characteristic == null) {
            console.error(`matchedDictionaryRow.characteristic is null`);
            return;
          } else if (matchedDictionaryRow.characteristic in row) {
            if (row[matchedDictionaryRow.characteristic] !== null)
              row[matchedDictionaryRow.characteristic] = formatData(
                matchedDictionaryRow,
                row[matchedDictionaryRow.characteristic]
              );
          } else {
            console.error(`Did not find key ${matchedDictionaryRow.characteristic} in row`);
          }
          // if (index == 0) {
          //   console.log(
          //     `${matchedDictionaryRow.characteristic} -> ${matchedDictionaryRow.abbreviation}`
          //   );
          // }
        });
        return row;
      });
      // console.log('');
      return formattedData;
    } catch (error) {
      console.error(error);
      return data;
    }
  };

  return {
    parseData,
    formatData,
    localDictionary,
    dictionaryFilterRows,
  };
};
